module.exports = __webpack_public_path__ + "img/panelView_baoSteel_3_3_.ef92b2ba.png";